// HTML
export default `<svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 11L5.15627 7.53644C6.11578 6.73685 6.11578 5.26315 5.15627 4.46356L1 1" stroke="#C4C4C4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
</svg>
`